import { useEffect, useState } from "react"
import { createAuthenticatedFileObjectUrl, requiresAuthenticatedFileFetch } from "@/lib/apiUtils"

export function useAuthenticatedImageUrl(source: string | null | undefined): string | null {
	const [displayUrl, setDisplayUrl] = useState<string | null>(() => {
		if (!source || requiresAuthenticatedFileFetch(source)) return null
		return source
	})

	useEffect(() => {
		let cancelled = false
		let objectUrl: string | null = null

		if (!source) {
			setDisplayUrl(null)
			return () => {}
		}

		if (!requiresAuthenticatedFileFetch(source)) {
			setDisplayUrl(source)
			return () => {}
		}

		setDisplayUrl(null)
		createAuthenticatedFileObjectUrl(source)
			.then((url) => {
				if (cancelled) {
					if (url) URL.revokeObjectURL(url)
					return
				}
				objectUrl = url
				setDisplayUrl(url)
			})
			.catch(() => {
				if (!cancelled) setDisplayUrl(null)
			})

		return () => {
			cancelled = true
			if (objectUrl) URL.revokeObjectURL(objectUrl)
		}
	}, [source])

	if (source && requiresAuthenticatedFileFetch(source) && displayUrl === source) return null
	return displayUrl
}
